import {Component, Input, OnInit} from '@angular/core';
import {FinantialProject} from '../../../../class/lifeproject/finantial-project';
import {LifeProjectBaseEditorComponent} from '../life-project-base-editor/life-project-base-editor.component';
import {LifeProject} from '../../../../class/lifeproject/life-project';
import {WelfareResultService} from '../../../../service/welfare-result.service';

@Component({
  selector: 'app-finatial',
  templateUrl: './finatial.component.html',
  styleUrls: ['./finatial.component.css']
})
export class FinatialComponent extends LifeProjectBaseEditorComponent implements OnInit {

  @Input()
  finantialProject: FinantialProject;

  import = 0;

  constructor(welfareService: WelfareResultService) {
    super(welfareService);
  }

  ngOnInit() {
  }

  calMonthValue() {

    if(!this.finantialProject.otherMoney){
      this.finantialProject.otherMoney = 0;
    }
    if(!this.finantialProject.rate){
      this.finantialProject.rate = 0;
    }

    const i = (this.finantialProject.rate / 100) / 12;

    const neededValue = this.finantialProject.importValue - this.finantialProject.savedMoney - this.finantialProject.otherMoney;

    if (neededValue > 0) {

      const expireIn = Math.round(this.finantialProject.yearToGoal * 12);

      if (i > 0) {

        this.finantialProject.monthValue = neededValue * i / (1 - Math.pow(i + 1, -expireIn));

        this.finantialProject.monthValue = Math.round(this.finantialProject.monthValue * 100) / 100;

      } else {
        this.finantialProject.yearCost = neededValue / this.finantialProject.yearToGoal;
        this.finantialProject.monthValue = this.finantialProject.yearCost / 12;
      }

      // set annual cost
      this.finantialProject.yearCost = this.finantialProject.monthValue * 12;

      this.finantialProject.totalCost = neededValue;

    }
  }

  getLifeProjectImpl(): LifeProject {
    return this.finantialProject;
  }

  updateSavedValue(check: boolean) {
    if (!check) {
      this.finantialProject.otherMoney = 0;
    }
  }
}
